import { PermissionsEnum } from '@/auth/interfaces';

export const SAVE_OT_PERMISSIONS_ACTIVACION = [
  PermissionsEnum.api_view_nap,
  PermissionsEnum.api_view_nodo,
  PermissionsEnum.api_view_olt,
  PermissionsEnum.api_view_router,
];
